// normalised to use keys returned by mastercard
const resolveErrorMessage = (field, error) =>
  ({
    cardNumber: {
      missing: 'Card number is required',
      invalid: 'Card number is invalid',
    },
    nameOnCard: {
      missing: 'Name on card is required',
    },
    securityCode: {
      missing: 'CVV is required',
      invalid: 'CVV is invalid',
    },
    expiryMonth: {
      missing: 'Expiry month is required',
      invalid: 'Expiry date is in invalid',
    },
    expiryYear: {
      missing: 'Expiry year is required',
    },
  }[field][error] || 'Field is invalid');

export default resolveErrorMessage;
